<div class="response-actions-content">
  <div class="response-section">
    <hyperkit-typography
      id="analystRunbook"
      variant="emphasized"
      size="sm"
      align="left"
      color="primary"
      >Analyst Runbook</hyperkit-typography
    >
    @if (analystRunbook) {
      <hyperkit-markdown
        variant="body"
        size="md"
        [md]="analystRunbook"
      ></hyperkit-markdown>
    } @else {
      <hyperkit-typography
        display="block"
        variant="body"
        align="left"
        color="primary"
        >--</hyperkit-typography
      >
    }
  </div>

  <div class="response-section">
    <hyperkit-typography
      id="mitigationRecommendations"
      variant="emphasized"
      size="sm"
      align="left"
      color="primary"
      >Mitigation Recommendations</hyperkit-typography
    >
    @if (mitigationRecommendations) {
      <hyperkit-markdown [md]="mitigationRecommendations"></hyperkit-markdown>
    } @else {
      <hyperkit-typography
        display="block"
        variant="body"
        align="left"
        color="primary"
        >--</hyperkit-typography
      >
    }
  </div>

  @if (playbook) {
    <div class="response-section">
      <hyperkit-typography variant="body" size="md" align="left" color="primary"
        >Profile</hyperkit-typography
      >
      <p>{{ playbook }}</p>
    </div>
  }
</div>
